export const resetStoreFns = new Set<() => void>();

export const resetAllStores = () => {
  resetStoreFns.forEach((resetFn) => {
    resetFn();
  });
};
